/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import rest from '../../../client/js/lib/rest'

export async function fetchAuthDetails () {
  const r = await rest.get('/api/auth')
  return await r.json()
}

/**
 * Logs user in with username and password.
 * @param username
 * @param password
 */
export async function signInWithPassword (username: string, password: string) {
  const r = await rest.post('/api/auth', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ username, password })
  })
  return await r.json()
}

/**
 * Logs user out.
 */
export function signOut () {
  return rest.post('/api/sign-out')
}
